export const Types = {
  //Get - List
  GET_CUSTOMERS_LIST_REQUEST: 'GET_CUSTOMERS_LIST_REQUEST',
  GET_CUSTOMERS_LIST_SUCCESS: 'GET_CUSTOMERS_LIST_SUCCESS',
  GET_CUSTOMERS_LIST_FAIL: 'GET_CUSTOMERS_LIST_FAIL',

  //Set for Update list
  SET_UPDATE_CUSTOMERS_LIST: 'SET_UPDATE_CUSTOMERS_LIST',

  //Store - Add
  POST_CUSTOMERS_ADD_REQUEST: 'POST_CUSTOMERS_ADD_REQUEST',
  POST_CUSTOMERS_ADD_SUCCESS: 'POST_CUSTOMERS_ADD_SUCCESS',
  POST_CUSTOMERS_ADD_FAIL: 'POST_CUSTOMERS_ADD_FAIL',

  //Update - Edit
  PUT_CUSTOMERS_EDIT_REQUEST: 'PUT_CUSTOMERS_EDIT_REQUEST',
  PUT_CUSTOMERS_EDIT_SUCCESS: 'PUT_CUSTOMERS_EDIT_SUCCESS',
  PUT_CUSTOMERS_EDIT_FAIL: 'PUT_CUSTOMERS_EDIT_FAIL',

  //Delete
  DELETE_CUSTOMERS_DEL_REQUEST: 'DELETE_CUSTOMERS_DEL_REQUEST',
  DELETE_CUSTOMERS_DEL_SUCCESS: 'DELETE_CUSTOMERS_DEL_SUCCESS',
  DELETE_CUSTOMERS_DEL_FAIL: 'DELETE_CUSTOMERS_DEL_FAIL',


  //CLear 
  CLEAR_ALL_REQUEST: 'CLEAR_ALL_REQUEST',
};

const INITIAL_STATE = {
  dataList: [],
  loadingList: false,
  errorList: false,
  errorDataList: false,
  dataListUpdate: false,

  loadingAdd: false,
  errorAdd: false,
  errorDataAdd: false,

  loadingEdit: false,
  errorEdit: false,
  errorDataEdit: false,

  loadingDelete: false,
  errorDelete: false,
  errorDataDelete: false,

};

export default function customers(state = INITIAL_STATE, action) {
  switch (action.type) {
    //Get - List
    case Types.GET_CUSTOMERS_LIST_REQUEST:
      return {
        ...state,
        loadingList: true,
        errorList: false,
      };
    case Types.GET_CUSTOMERS_LIST_SUCCESS:
      return {
        ...state,
        dataList: action.payload,
        loadingList: false,
        errorList: false,
        errorDataList: false
      };
    case Types.GET_CUSTOMERS_LIST_FAIL:
      return {
        ...state,
        dataList: false,
        loadingList: false,
        errorList: true,
        errorDataList: action.payload,
      };

    case Types.SET_UPDATE_CUSTOMERS_LIST:
      return {
        ...state,
        dataListUpdate: action.payload,
      };

    //Store - Add
    case Types.POST_CUSTOMERS_ADD_REQUEST:
      return {
        ...state,
        loadingAdd: true,
        errorAdd: false,
      };
    case Types.POST_CUSTOMERS_ADD_SUCCESS:
      return {
        ...state,
        loadingAdd: false,
        errorAdd: false,
        errorDataAdd: false,
      };
    case Types.POST_CUSTOMERS_ADD_FAIL:
      return {
        ...state,
        loadingAdd: false,
        errorAdd: true,
        errorDataAdd: action.payload,
      };

    //Update - Edit
    case Types.PUT_CUSTOMERS_EDIT_REQUEST:
      return {
        ...state,
        loadingEdit: true,
        errorEdit: false,
      };
    case Types.PUT_CUSTOMERS_EDIT_SUCCESS:
      return {
        ...state,
        loadingEdit: false,
        errorEdit: false,
        errorDataEdit: false,
      };
    case Types.PUT_CUSTOMERS_EDIT_FAIL:
      return {
        ...state,
        loadingEdit: false,
        errorEdit: true,
        errorDataEdit: action.payload,
      };

    //Delete 
    case Types.DELETE_CUSTOMERS_DEL_REQUEST:
      return {
        ...state,
        loadingDelete: true,
        errorDelete: false,
      };
    case Types.DELETE_CUSTOMERS_DEL_SUCCESS:
      return {
        ...state,
        loadingDelete: false,
        errorDelete: false,
        errorDataDelete: false,
      };
    case Types.DELETE_CUSTOMERS_DEL_FAIL:
      return {
        ...state,
        loadingDelete: false,
        errorDelete: true,
        errorDataDelete: action.payload,
      };

    //Clear
    case Types.CLEAR_ALL_REQUEST:
      return {
        ...state,

        dataList: false,
        loadingList: false,
        errorList: false,
        errorDataList: false,
        dataListUpdate: false,

        loadingAdd: false,
        errorAdd: false,
        errorDataAdd: false,

        loadingEdit: false,
        errorEdit: false,
        errorDataEdit: false,

        loadingDelete: false,
        errorDelete: false,
        errorDataDelete: false,

      };

    default:
      return state;
  }
}

export const Creators = {

  //Get - List
  getCustomersListRequest: (payload) => ({
    type: Types.GET_CUSTOMERS_LIST_REQUEST,
    payload,
  }),
  getCustomersListRequestSuccess: (payload) => ({
    type: Types.GET_CUSTOMERS_LIST_SUCCESS,
    payload,
  }),
  getCustomersListRequestFail: (payload) => ({
    type: Types.GET_CUSTOMERS_LIST_FAIL,
    payload,
  }),

  setUpdateCustomers: (payload) => ({
    type: Types.SET_UPDATE_CUSTOMERS_LIST,
    payload,
  }),


  //Store - Add 
  postCustomersAddRequest: (payload) => ({
    type: Types.POST_CUSTOMERS_ADD_REQUEST,
    payload,
  }),
  postCustomersAddRequestSuccess: () => ({
    type: Types.POST_CUSTOMERS_ADD_SUCCESS,
  }),
  postCustomersAddRequestFail: (payload) => ({
    type: Types.POST_CUSTOMERS_ADD_FAIL,
    payload,
  }),

  //Update - Edit 
  putCustomersEditRequest: (payload) => ({
    type: Types.PUT_CUSTOMERS_EDIT_REQUEST,
    payload,
  }),
  putCustomersEditRequestSuccess: () => ({
    type: Types.PUT_CUSTOMERS_EDIT_SUCCESS,
  }),
  putCustomersEditRequestFail: (payload) => ({
    type: Types.PUT_CUSTOMERS_EDIT_FAIL,
    payload,
  }),

  //Delete 
  deleteCustomersDelRequest: (payload) => ({
    type: Types.DELETE_CUSTOMERS_DEL_REQUEST,
    payload,
  }),
  deleteCustomersDelRequestSuccess: () => ({
    type: Types.DELETE_CUSTOMERS_DEL_SUCCESS,
  }),
  deleteCustomersDelRequestFail: (payload) => ({
    type: Types.DELETE_CUSTOMERS_DEL_FAIL,
    payload,
  }),

  //Clear
  clearAllRequest: () => ({
    type: Types.CLEAR_ALL_REQUEST
  }),
};
